import React, { Component } from "react";
import PropTypes from 'prop-types';

class ClassicTitledTile extends Component {
  render = () => (
    <div className='classicTitledTile'>
      <div className={'title' + (!this.props.className ? '' : (' ' + this.props.className))}>
        {this.props.title}
      </div>
      <div className='contentSpace'>
        {this.props.children}
      </div>
    </div>
  );
}

ClassicTitledTile.propTypes = {
  title: PropTypes.any.isRequired,
  children: PropTypes.any,
  className: PropTypes.string
};

export default ClassicTitledTile;
